
export type Theme = {
  background: string;
  textColour: string;
  positiveActionColor: string;
  neutralActionColor: string;
  accentColour: string;
  errorColour: string;
  warningColour: string;
  accentBackground: string;
};
export type Font = {
  family: string;
  weight: number;
}

export type Typography = {
  header: Font;
  data: Font;
}

export const LightTheme: Theme = {
  background: "#f5f6f0",
  textColour: "#434343",
  neutralActionColor: "#00301b",
  positiveActionColor: "#00301b",
  accentColour: "#dea928", // "#DFE3DD",
  errorColour: "#9D624D",
  warningColour: "#eac67a",
  accentBackground: "#fefff9"
};


export const MainTypography: Typography = { 
  header: {
    family: "montserrat",
    weight: 500
  },
  data : {
    family: "montserrat",
    weight: 300
  }
}

export const DarkTheme: Theme = {
  background: "#f5f6f0",
  textColour: "#434343",
  neutralActionColor: "#00301b",
  positiveActionColor: "#00301b",
  accentColour: "#dea928", // "#DFE3DD",
  errorColour: "#9D624D",
  warningColour: "#eac67a",
  accentBackground: "#fefff9"
};

export type ThemePreferences = {
  isDarkMode: boolean;
  palette: Theme;
  typography: Typography;
};

export const generateUpdatedToggledThemeState = (
  isDarkMode: boolean
): ThemePreferences => ({
  isDarkMode: !isDarkMode,
  palette: isDarkMode ? LightTheme : DarkTheme,
  typography: MainTypography
});

